/* global DEPLOY_TARGET */

/*
 * Will only log in non-prod deployment targets.
 */
function devLogger(logger, ...message) {
  if (DEPLOY_TARGET === "production") {
    return;
  }

  logger(...message);
}

export { devLogger };
